import { isOnboardingComplete } from '@xavior/contracts';
import type { ContainerAccess, UserProfile } from '@/types/session';

export interface WorkspaceOnboarding {
  needsOnboarding: boolean;
  mode: 'owner' | 'member';
}

/** Per-workspace onboarding decision (team-member onboarding spec §C/§D).
 *  Reads the SELECTED container's membership onboarding + role; falls back to
 *  the user-level profile flag only when there is no selected container. */
export function resolveWorkspaceOnboarding(
  selected: Pick<ContainerAccess, 'role' | 'onboardingCompleted'> | null | undefined,
  profile: Pick<UserProfile, 'onboardingState'> | null | undefined,
): WorkspaceOnboarding {
  const mode: 'owner' | 'member' = selected?.role === 'member' ? 'member' : 'owner';
  if (!selected) {
    return { needsOnboarding: !isOnboardingComplete(profile?.onboardingState), mode };
  }
  return { needsOnboarding: selected.onboardingCompleted !== true, mode };
}
